import React from 'react';
import { AbonnementPrice } from '../priceElements/AbonnementPrice';
import { ExtraPrice } from '../priceElements/ExtraPrice';
import { InstallationLabel } from '../priceElements/InstallationLabel';
import { TotalPriceSmall } from '../priceElements/TotalPriceSmall';
import { PricePerEmployeeBig } from '../priceElements/PricePerEmployeeBig';
import { classNames } from '../../../utils/style';

export const EmployeePriceFeaturedTemplate = (args: any) => {
  return (
    <>
      {args?.pricePerEmployee > 0 && <PricePerEmployeeBig {...args} />}
      {(args?.abonnementPrice > 0 || args?.extraPrice > 0) && (
        <div className={classNames('text-neutral-101 text-12 mb-16')}>
          {args?.abonnementPrice && <AbonnementPrice {...args} />}
          {args?.extraPrice && <ExtraPrice {...args} />}
        </div>
      )}
      {args?.price > 0 && <TotalPriceSmall {...args} />}
      {args?.installationLabel && <InstallationLabel {...args} />}
    </>
  );
};
